import { render, staticRenderFns } from "./SettingCategory.vue?vue&type=template&id=05074954&"
import script from "./SettingCategory.vue?vue&type=script&lang=js&"
export * from "./SettingCategory.vue?vue&type=script&lang=js&"
import style0 from "./SettingCategory.vue?vue&type=style&index=0&id=05074954&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports